import { invoke } from '@tauri-apps/api/core';
import { getStoredDesktopAccount } from 'services/desktop-session';
/**
 * Fetch account meta via the Rust HTTP proxy.
 * Uses tenant get-mobile-meta when an account slug is known; otherwise admin get-meta.
 */ export async function fetchDesktopAccountMeta(domain) {
    const resolvedDomain = (domain === null || domain === void 0 ? void 0 : domain.trim()) || getStoredDesktopAccount() || undefined;
    const result = await invoke('desktop_get_account_meta', {
        domain: resolvedDomain !== null && resolvedDomain !== void 0 ? resolvedDomain : null
    });
    return JSON.parse(result.body);
}
